import React from 'react'
import { decode_utf8 } from '../../../../common/utils/utilsFunc'
import DebtAndEndowmentPublic from '../DebtAndEndowmentPublic'


const DebtAndEndowmentControllerPub = ({ props, canal }) => {

    return (
        <div className="container-table">
            <nav>
                <ul className="nav nav-tabs nav-justified" id="myTab" role="tablist">
                    <li className="nav-item">
                        <a className="nav-link active" id="certificado-deuda" data-toggle="tab" href="#certificadoDeuda" role="tab" aria-controls="certificadoDeuda" aria-selected="true" data-lineheight="30" data-fontsize="18" >Certificado de Deuda</a>
                    </li>

                    <li className="nav-item">
                        <a className="nav-link" id="certificado-dotacion" data-toggle="tab" href="#certificadoDotatcion" role="tab" aria-controls="certificadoDotatcion" aria-selected="false" data-lineheight="30" data-fontsize="18" >Certificado de Dotacion</a>
                    </li>
                </ul>
            </nav>
            <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="certificadoDeuda" role="tabpanel" aria-labelledby="certificado-deuda">
                    <DebtAndEndowmentPublic
                        props={props}
                        canal={canal}
                        title={decode_utf8(props.titulo_emision_certificado_deuda)}
                        description={decode_utf8(props.descripcione_emision_certificado_deuda)}
                        typeCertificate="DE"
                    />
                </div>
                <div class="tab-pane fade" id="certificadoDotatcion" role="tabpanel" aria-labelledby="certificado-dotacion">
                    <DebtAndEndowmentPublic
                        props={props}
                        canal={canal}
                        title={decode_utf8(props.titulo_emision_certificado_dotacion)}
                        description={decode_utf8(props.descripcione_emision_certificado_dotacion)}
                        typeCertificate="DO"
                    />
                </div>

            </div>

        </div>
    )
}

export default DebtAndEndowmentControllerPub